import { keyLocalStorage } from "helpers/constants";
import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  children: ReactNode;
}
const Authenticate = ({ children }: Props) => {
  const navigate = useNavigate();

  const isAuthenticated = JSON.parse(
    localStorage.getItem(keyLocalStorage.USER_STORAGE)!
  );

  useEffect(() => {
    if (!isAuthenticated) {
      navigate({ pathname: "/authentication/sign-in/basic" });
    }
  }, [isAuthenticated, navigate]);

  return <>{children}</>;
};

export default Authenticate;
